module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-705bbdf2db3c4668c8750804ca12d962.woff";